var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (fair, primarySets, profile, undefined) {
buf.push("<div class=\"fair-overview-top\"><div class=\"fair-overview-top-left\"><img" + (jade.attr("alt", fair.get('name'), true, true)) + (jade.attr("title", fair.get('name'), true, true)) + (jade.attr("src", profile.icon().imageUrl('square'), true, true)) + " class=\"large-profile-image\"><h1 class=\"fair-name\">" + (jade.escape(null == (jade_interp = fair.get('name')) ? "" : jade_interp)) + "</h1><div class=\"fair-location\">" + (jade.escape(null == (jade_interp = fair.formatLocation()) ? "" : jade_interp)) + "</div><div class=\"fair-dates\">" + (jade.escape(null == (jade_interp = fair.formatDates()) ? "" : jade_interp)) + "</div>");
if ( fair.has('tagline'))
{
buf.push("<div class=\"fair-tagline\">" + (jade.escape(null == (jade_interp = fair.get('tagline')) ? "" : jade_interp)) + "</div>");
}
if ( profile.get('bio'))
{
buf.push("<div class=\"profile-bio\">" + (null == (jade_interp = profile.mdToHtml('bio') + ' ') ? "" : jade_interp) + "</div>");
}
buf.push("<div class=\"clock\"><div class=\"clock-header\"></div><ul class=\"clock-value\"></ul></div></div><div class=\"fair-overview-right\"><a" + (jade.attr("href", profile.href() + "/browse", true, true)) + " class=\"fair-overview-browse\"><div" + (jade.attr("style", "background-image: url(" + fair.imageUrl('large_rectangle') + ")", true, true)) + " class=\"fair-overview-browse-image\"></div><div class=\"fair-overview-browse-heading overview-heading\">Browse all exhibitors</div><div class=\"fair-overview-browse-subheading\">Updated Daily</div></a></div></div><div class=\"fair-overview-below-top-container\"><div class=\"fair-overview-below-top\"><div class=\"container-left\"><div class=\"fair-follow\"><p>Follow the fair for updates and personalized recommendations.</p><button id=\"fair-follow-button\"" + (jade.attr("data-id", fair.get('default_profile_id'), true, true)) + " class=\"avant-garde-follow-button-black follow-button no-touch\"></button></div>");
if ( primarySets.where({ key: 'explore' }))
{
// iterate primarySets.where({ key: 'explore' })
;(function(){
  var $$obj = primarySets.where({ key: 'explore' });
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var set = $$obj[$index];

// iterate set.get('items').models.slice(0,2)
;(function(){
  var $$obj = set.get('items').models.slice(0,2);
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

buf.push("<a" + (jade.attr("href", item.get('href'), true, true)) + " class=\"small-section\"><img" + (jade.attr("src", item.imageUrl('large_square'), true, true)) + "><h2 class=\"section-heading\">" + (jade.escape(null == (jade_interp = item.get('title')) ? "" : jade_interp)) + "</h2></a>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var item = $$obj[$index];

buf.push("<a" + (jade.attr("href", item.get('href'), true, true)) + " class=\"small-section\"><img" + (jade.attr("src", item.imageUrl('large_square'), true, true)) + "><h2 class=\"section-heading\">" + (jade.escape(null == (jade_interp = item.get('title')) ? "" : jade_interp)) + "</h2></a>");
    }

  }
}).call(this);

    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var set = $$obj[$index];

// iterate set.get('items').models.slice(0,2)
;(function(){
  var $$obj = set.get('items').models.slice(0,2);
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

buf.push("<a" + (jade.attr("href", item.get('href'), true, true)) + " class=\"small-section\"><img" + (jade.attr("src", item.imageUrl('large_square'), true, true)) + "><h2 class=\"section-heading\">" + (jade.escape(null == (jade_interp = item.get('title')) ? "" : jade_interp)) + "</h2></a>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var item = $$obj[$index];

buf.push("<a" + (jade.attr("href", item.get('href'), true, true)) + " class=\"small-section\"><img" + (jade.attr("src", item.imageUrl('large_square'), true, true)) + "><h2 class=\"section-heading\">" + (jade.escape(null == (jade_interp = item.get('title')) ? "" : jade_interp)) + "</h2></a>");
    }

  }
}).call(this);

    }

  }
}).call(this);

}
buf.push("</div>");
if ( primarySets.where({ key: 'primary' }))
{
buf.push("<div class=\"container-right\">");
// iterate primarySets.where({ key: 'primary' })
;(function(){
  var $$obj = primarySets.where({ key: 'primary' });
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var set = $$obj[$index];

// iterate set.get('items').models.slice(0,3)
;(function(){
  var $$obj = set.get('items').models.slice(0,3);
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

buf.push("<a" + (jade.attr("href", item.get('href'), true, true)) + " class=\"small-section\"><img" + (jade.attr("src", item.imageUrl('large_square'), true, true)) + "><h2 class=\"section-heading\">" + (jade.escape(null == (jade_interp = item.get('title')) ? "" : jade_interp)) + "</h2></a>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var item = $$obj[$index];

buf.push("<a" + (jade.attr("href", item.get('href'), true, true)) + " class=\"small-section\"><img" + (jade.attr("src", item.imageUrl('large_square'), true, true)) + "><h2 class=\"section-heading\">" + (jade.escape(null == (jade_interp = item.get('title')) ? "" : jade_interp)) + "</h2></a>");
    }

  }
}).call(this);

if ( set.get('items').models[3])
{
buf.push("<a" + (jade.attr("href", set.get('items').models[3].get('href'), true, true)) + " class=\"small-section primary-section-top-right\"><img" + (jade.attr("src", set.get('items').models[3].imageUrl('large_square'), true, true)) + "><h2 class=\"section-heading\">" + (jade.escape(null == (jade_interp = set.get('items').models[3].get('title')) ? "" : jade_interp)) + "</h2></a>");
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var set = $$obj[$index];

// iterate set.get('items').models.slice(0,3)
;(function(){
  var $$obj = set.get('items').models.slice(0,3);
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

buf.push("<a" + (jade.attr("href", item.get('href'), true, true)) + " class=\"small-section\"><img" + (jade.attr("src", item.imageUrl('large_square'), true, true)) + "><h2 class=\"section-heading\">" + (jade.escape(null == (jade_interp = item.get('title')) ? "" : jade_interp)) + "</h2></a>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var item = $$obj[$index];

buf.push("<a" + (jade.attr("href", item.get('href'), true, true)) + " class=\"small-section\"><img" + (jade.attr("src", item.imageUrl('large_square'), true, true)) + "><h2 class=\"section-heading\">" + (jade.escape(null == (jade_interp = item.get('title')) ? "" : jade_interp)) + "</h2></a>");
    }

  }
}).call(this);

if ( set.get('items').models[3])
{
buf.push("<a" + (jade.attr("href", set.get('items').models[3].get('href'), true, true)) + " class=\"small-section primary-section-top-right\"><img" + (jade.attr("src", set.get('items').models[3].imageUrl('large_square'), true, true)) + "><h2 class=\"section-heading\">" + (jade.escape(null == (jade_interp = set.get('items').models[3].get('title')) ? "" : jade_interp)) + "</h2></a>");
}
    }

  }
}).call(this);

buf.push("</div>");
}
buf.push("</div></div>");}.call(this,"fair" in locals_for_with?locals_for_with.fair:typeof fair!=="undefined"?fair:undefined,"primarySets" in locals_for_with?locals_for_with.primarySets:typeof primarySets!=="undefined"?primarySets:undefined,"profile" in locals_for_with?locals_for_with.profile:typeof profile!=="undefined"?profile:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;